// extracted by mini-css-extract-plugin
export default {"MethodsList":"CashIn_MethodsList__9bm1B","CashinByPhone":"CashIn_CashinByPhone__hVRAr"};